// extracted by mini-css-extract-plugin
export default {"offerShortItem":"OfferShort_offerShortItem__+p-qA","offerShortLink":"OfferShort_offerShortLink__YMka3","offerShortEditLink":"OfferShort_offerShortEditLink__fQ99G"};